import axios from "axios";

import { LOGIN_API_URL } from "../config/apiConfig";

const axiosClient = axios.create({
    // .env.local -> http://localhost:8080/tenant-management ; .env.production -> gateway
    baseURL: LOGIN_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

/**
 * En-tête déjà fixé par l'appel (lien « choisir mon mot de passe », connexion) : il prime sur la
 * session enregistrée. Sinon un lien ouvert dans un navigateur où un autre compte s'est connecté
 * partait avec le pays de ce compte (autre base), et le serveur le jugeait « expiré ».
 */
const hasHeader = (headers, name) =>
    typeof headers.has === "function"
        ? headers.has(name)
        : Object.keys(headers).some((key) => key.toLowerCase() === name.toLowerCase());

// 🔥 Interceptor global
axiosClient.interceptors.request.use((config) => {

    const countryCode =
        localStorage.getItem("countryCode");
    const token = localStorage.getItem("token");

    // ✅ toujours OK
    if (countryCode && !hasHeader(config.headers, "X-Tenant-Country")) {
        config.headers["X-Tenant-Country"] = countryCode;
    }

    // 🚨 NE PAS envoyer token sur login
    const isAuthRequest = config.url.includes("/auth/login")
        || config.url.includes("/auth/googleWithVerification")
        || config.url.includes("/auth/set-password");

    if (token && !isAuthRequest) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
});

export default axiosClient;


